import { render, staticRenderFns } from "./SVG-PlusMinus.vue?vue&type=template&id=c9b7d1f0&lang=pug&"
import script from "./SVG-PlusMinus.vue?vue&type=script&lang=js&"
export * from "./SVG-PlusMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports